package com.partejar.app.core.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.partejar.app.core.ui.theme.PartejarTheme

@Composable
fun PartejarDockScaffold(
    modifier: Modifier = Modifier,
    topBar: @Composable () -> Unit = {},
    content: @Composable (scaffoldPadding: PaddingValues, dockClearance: Dp) -> Unit
) {
    val spacing = PartejarTheme.spacing
    val dimensions = PartejarTheme.dimensions
    val windowSize = partejarWindowSize

    val navigationBarHeight = WindowInsets.navigationBars
        .asPaddingValues()
        .calculateBottomPadding()

    val dockClearance = if (windowSize == PartejarWindowSize.EXPANDED) {
        PartejarLayout.desktopDockClearance + navigationBarHeight
    } else {
        dimensions.floatingDockMinHeight + spacing.space64 + navigationBarHeight
    }

    Box(
        modifier = modifier.fillMaxSize()
    ) {
        Scaffold(
            modifier = Modifier.fillMaxSize(),
            containerColor = MaterialTheme.colorScheme.background,
            contentColor = MaterialTheme.colorScheme.onBackground,
            contentWindowInsets = WindowInsets(0, 0, 0, 0),
            topBar = topBar,
            content = { scaffoldPadding ->
                content(scaffoldPadding, dockClearance)
            }
        )
    }
}
